export default __webpack_public_path__ + "static/media/Logo_Apolo.d8a5c8ff.png";